import {
  JobCard,
  Meter,
  ServiceProcedure,
  SOPTemplate,
  TransformedServiceOrder,
  TransformedServiceProcedure,
} from "./types";

// Helper function for priority - will come from API in future
const getPriority = (jobCard: JobCard): string => {
  // TODO: Priority will come as string from API in future
  // For now, return default value
  return "Medium"; // Default priority until API provides it
};

// Helper function to determine mode type
const deriveModeType = (jobCard: JobCard): string => {
  // You can adjust this logic based on your business rules
  // For now, defaulting to "Single" - you might want to derive this from other fields
  return "Single";
};

// Helper function to format date for display
const formatDateForDisplay = (dateString: string): string => {
  if (!dateString) return "";

  try {
    const date = new Date(dateString);
    return date.toISOString().split("T")[0]; // Returns YYYY-MM-DD format
  } catch (error) {
    return dateString; // Return original if parsing fails
  }
};

// ✅ NEW: Helper function to create technician object for existing UI

// ✅ NEW: Helper function to format date/time for assigned on field
const formatAssignedOnForDisplay = (assignDate: string | null): string => {
  if (!assignDate) return "";

  try {
    const date = new Date(assignDate);
    return date
      .toLocaleString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      })
      .replace(",", "");
  } catch (error) {
    return assignDate || "";
  }
};
export const transformMeterData = (meters: any[]) => {
  console.log("CONCCCC", meters);
  const transformed = meters.map((meter, index) => {
    const result = {
      id: meter.id?.toString(),
      meterNo: meter.meterNo || meter.meterNumber || "N/A",
      type: meter.meterType || meter.type || "NA",
      deviceNo: meter.deviceNo || meter.deviceNumber || "N/A",
      productCode: meter.productCode || meter.productId || "N/A",
      assignmentStatus: meter.status || "NA",
      assignmentStatusDisplay: meter.statusDisplay || "NA",
      meterTypeDisplay: meter.meterTypeDisplay || "NA",
      physicalStatus: meter.physicalStatus || "NA",
      physicalStatusDisplay: meter.physicalStatusDisplay || "NA",
      currentReading: meter.readingStatusDisplay || "N/A",
      area: meter.areaName || "N/A",
      premise: meter.premise || "N/A",
      originalData: meter, // ✅ PRESERVE ALL ORIGINAL DATA
    };

    return result;
  });

  return transformed;
};

export const transformAssetData = (assets: any[]) => {
  console.log("asset", assets);
  const transformed = assets.map((asset, index) => {
    const result = {
      id: asset.id?.toString(),
      assetNo: asset.assetNo || asset.assetNumber || asset.asset_no || asset.asset_number || asset.networkNo || asset.network_no || asset.facilityNo || asset.facility_no || asset.systemNo || asset.system_no || "N/A",
      assetName: asset.assetName || asset.name || asset.asset_name || asset.networkName || asset.network_name || asset.facilityName || asset.facility_name || asset.systemName || asset.system_name || "NA",
      statusDisplay: asset.statusDisplay || asset.status_display || asset.statusLabel || asset.status_label || "N/A",
      createdDate: asset.createdDate || asset.created_date || "N/A",
      description: asset.description || asset.description || "NA",
      originalData: asset, // ✅ PRESERVE ALL ORIGINAL DATA
    };

    return result;
  });

  return transformed;
};

// Main transformer function
export const transformJobCardToServiceOrder = (
  jobCard: JobCard
): TransformedServiceOrder => {
  return {
    // Preserve all original API fields (keeping existing functionality)
    id: jobCard.id,
    jobCardNo: jobCard.jobCardNo,
    remoteUtilityId: jobCard.remoteUtilityId,
    requestUsername: jobCard.requestUsername,
    mobileNumber: jobCard.mobileNumber,
    requestAccountNo: jobCard.requestAccountNo,
    createdDate: jobCard.createdDate,
    expectedEndDate: jobCard.expectedEndDate,
    status: jobCard.status,
    area: jobCard.area,
    subArea: jobCard.subArea,
    premise: jobCard.premise,
    latitude: jobCard.latitude,
    longitude: jobCard.longitude,
    completedDate: jobCard.completedDate,
    approvedDate: jobCard.approvedDate,
    assignDate: jobCard.assignDate,
    sop: jobCard.sop,
    requestId: jobCard.requestId,
    sopAssociationType: jobCard.sopAssociationType,
    fieldForceName: jobCard.fieldForceName,
    sopName: jobCard.sopName,
    serviceNo: jobCard.serviceNo,
    sopUtilityService: jobCard.sopUtilityService,
    sopShortName: jobCard.sopShortName,
    statusDisplay: jobCard.statusDisplay,
    createdTime: jobCard.createdTime,
    assignTime: jobCard.assignTime,
    approvedTime: jobCard.approvedTime,
    completedTime: jobCard.completedTime,
    premiseName: jobCard.premiseName,
    areaName: jobCard.areaName,
    subAreaName: jobCard.subAreaName,
    sopAssociationTypeDisplay: jobCard.sopAssociationTypeDisplay,
    slaStatus: jobCard.slaStatus,

    // Existing transformed fields for UI compatibility (keeping existing functionality)
    name: jobCard.sopName,
    serviceAssociation: jobCard.sopAssociationTypeDisplay || "NA",
    createdOn: formatDateForDisplay(jobCard.createdDate),
    priority: jobCard.priorityDisplay,
    modeType: deriveModeType(jobCard),
    number: 1, // Default value, adjust as needed

    // ✅ NEW: Additional fields for assigned service orders UI compatibility
    soId: jobCard.jobCardNo || jobCard.id?.toString(),
    soName: jobCard.sopName,
    referenceNo:
      jobCard.requestAccountNo || jobCard.serviceNo || jobCard.jobCardNo,
    technician: { name: jobCard.fieldForceName, id: jobCard.fieldForceNo },
    assignedOn: formatAssignedOnForDisplay(jobCard.assignDate),
    eta: jobCard.expectedEndDate || "",

    priorityDisplay: jobCard.priorityDisplay,
  };
};
export const buildMeterLocations = (
  selectedEntities: any[],
  serviceAssociation: string
): string[] => {
  // Only include meter locations if association is "Meter"
  if (serviceAssociation !== "Meter") {
    return [];
  }

  return selectedEntities
    .filter((entity) => {
      // Check if entity has valid lat/long coordinates
      const lat = entity.originalData?.lat;
      const long = entity.originalData?.long;
      return (
        lat &&
        long &&
        lat !== "NA" &&
        long !== "NA" &&
        lat !== null &&
        long !== null
      );
    })
    .map((entity) => {
      const lat = entity.originalData.lat;
      const long = entity.originalData.long;
      return `(${lat}, ${long})`;
    });
};

// Transform array of job cards (keeping existing functionality)
export const transformJobCardsToServiceOrders = (
  jobCards: JobCard[]
): TransformedServiceOrder[] => {
  return jobCards.map(transformJobCardToServiceOrder);
};
export const serviceProcedureUtils = {
  // Transform service procedure for UI display
  transformServiceProcedure: (
    procedure: ServiceProcedure
  ): TransformedServiceProcedure => {
    const materialCost = procedure.material_cost_count || 0;
    const laborCost =
      ((procedure.task_time_count || 0) * (procedure.rate || 0)) / 60; // Assuming rate is per hour
    const otherCost = procedure.estimated_other_cost || 0;
    const taxRate = procedure.tax ? parseFloat(procedure.tax.split("#")[0]) : 0;
    const taxAmount = (materialCost + laborCost + otherCost) * (taxRate / 100);
    const totalCost = materialCost + laborCost + otherCost + taxAmount;

    return {
      id: procedure.id,
      serviceNo: procedure.service_no,
      name: procedure.name,
      version: procedure.version,
      sopType: procedure.sop_type,
      sopSubtype: procedure.sop_subtype,
      shortName: procedure.short_name,
      description: procedure.description,
      priorityDisplay: procedure.priorityDisplay,
      totalCost,
      totalTime: procedure.task_time_count || 0,
      totalDowntime: procedure.total_downtime || 0,
      taskCount: procedure.task?.length || 0,
      materialCount: procedure.material?.length || 0,
      isComplexProcedure:
        (procedure.task?.length || 0) > 3 ||
        (procedure.material?.length || 0) > 2,

      associationType: procedure.sop_association_type_display,
      utilityServices: procedure.utility_services || [],
      status: procedure.is_active ? "Active" : "Inactive",
      createdBy: procedure.created_user_remote_name,
      usageCount: procedure.usage_count,

      costBreakdown: {
        materialCost,
        laborCost,
        otherCost,
        taxAmount,
        totalCost,
      },

      timeBreakdown: {
        totalTaskTime: procedure.task_time_count || 0,
        totalDowntime: procedure.total_downtime || 0,
        estimatedDuration:
          (procedure.task_time_count || 0) + (procedure.total_downtime || 0),
      },
    };
  },

  // Transform array of service procedures
  transformServiceProcedures: (
    procedures: ServiceProcedure[]
  ): TransformedServiceProcedure[] => {
    return procedures.map(serviceProcedureUtils.transformServiceProcedure);
  },

  // Calculate total cost including tax
  calculateTotalCost: (procedure: ServiceProcedure): number => {
    const materialCost = procedure.material_cost_count || 0;
    const laborCost =
      ((procedure.task_time_count || 0) * (procedure.rate || 0)) / 60;
    const otherCost = procedure.estimated_other_cost || 0;
    const subtotal = materialCost + laborCost + otherCost;

    if (procedure.tax) {
      const taxRate = parseFloat(procedure.tax.split("#")[0]);
      return subtotal * (1 + taxRate / 100);
    }

    return subtotal;
  },

  // Get complexity level based on tasks and materials
  getComplexityLevel: (
    procedure: ServiceProcedure
  ): "Simple" | "Medium" | "Complex" => {
    const taskCount = procedure.task?.length || 0;
    const materialCount = procedure.material?.length || 0;
    const totalItems = taskCount + materialCount;

    if (totalItems <= 2) return "Simple";
    if (totalItems <= 5) return "Medium";
    return "Complex";
  },

  // Get estimated duration in human readable format
  getEstimatedDuration: (procedure: ServiceProcedure): string => {
    const totalMinutes =
      (procedure.task_time_count || 0) + (procedure.total_downtime || 0);

    if (totalMinutes < 60) {
      return `${totalMinutes} minutes`;
    } else {
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`;
    }
  },

  // Filter procedures by criteria
  filterProcedures: (
    procedures: ServiceProcedure[],
    criteria: {
      type?: string;
      subtype?: string;
      association?: string;
      utility?: string;
      isActive?: boolean;
    }
  ): ServiceProcedure[] => {
    return procedures.filter((procedure) => {
      if (criteria.type && procedure.sop_type !== criteria.type) return false;
      if (criteria.subtype && procedure.sop_subtype !== criteria.subtype)
        return false;
      if (
        criteria.association &&
        procedure.sop_association_type !== criteria.association
      )
        return false;
      if (
        criteria.utility &&
        !procedure.utility_services?.includes(criteria.utility)
      )
        return false;
      if (
        criteria.isActive !== undefined &&
        procedure.is_active !== criteria.isActive
      )
        return false;
      return true;
    });
  },

  // Search procedures by term
  searchProcedures: (
    procedures: ServiceProcedure[],
    searchTerm: string
  ): ServiceProcedure[] => {
    if (!searchTerm.trim()) return procedures;

    const term = searchTerm.toLowerCase();
    return procedures.filter(
      (procedure) =>
        procedure.name.toLowerCase().includes(term) ||
        procedure.description?.toLowerCase().includes(term) ||
        procedure.service_no.toLowerCase().includes(term) ||
        procedure.short_name.toLowerCase().includes(term)
    );
  },

  // Get unique values for filters
  getUniqueValues: (procedures: ServiceProcedure[]) => ({
    types: [...new Set(procedures.map((p) => p.sop_type))].filter(Boolean),
    subtypes: [...new Set(procedures.map((p) => p.sop_subtype))].filter(
      Boolean
    ),
    associations: [
      ...new Set(procedures.map((p) => p.sop_association_type_display)),
    ].filter(Boolean),
    utilities: [
      ...new Set(procedures.flatMap((p) => p.utility_services || [])),
    ].filter(Boolean),
    creators: [
      ...new Set(procedures.map((p) => p.created_user_remote_name)),
    ].filter(Boolean),
  }),
};
export const mapApiDataToSOPTemplate = (apiData: any): SOPTemplate => {
  console.log("SELECTED SOP1", apiData);
  return {
    id: apiData.id,
    name: apiData.name,
    shortName: apiData.shortName,
    soId: apiData.shortName.charAt(0).toUpperCase(), // First letter of short name
    association: apiData.sopAssociationTypeDisplay,
    description: apiData.description,
    tat: apiData.taskTimeCount || "NA",
    priority: apiData.usageCount,
    estimatedCost: apiData.estTotalCost || 0,
    estimatedTime: apiData.taskTimeCount || 0,
    estimatedDowntime: apiData.totalDowntime || 0,
    estimatedEffort: apiData.taskTimeCount || 0, // Assuming effort = task time
    sla: apiData.sopType,
    tag: apiData.usageCount,
    isOverdue: apiData.usageCount, // Example logic
    premiseCode: apiData.premiseCode,

    // Additional API fields
    serviceNo: apiData.serviceNo,
    version: apiData.version,
    sopType: apiData.sopType,
    sopSubtype: apiData.sopSubtype,
    utilityServices: apiData.utilityServices || [],
    estTotalCost: apiData.estTotalCost || 0,
    materialCostCount: apiData.materialCostCount || 0,
    totalDowntime: apiData.totalDowntime || 0,
    taskTimeCount: apiData.taskTimeCount || 0,
    tasks: apiData.task || [],
    materials: apiData.material || [],
    rate: apiData.rate || 0,
    tax: apiData.tax || "",
    taxName: apiData.taxName || "",
    usageCount: apiData.usageCount || 0,
    createdUserRemoteName: apiData.createdUserRemoteName || "",
    sopAssociationType: apiData.sopAssociationType || "0",
    estimatedOtherCost: apiData.estimatedOtherCost || 0,
  };
};
